import { ManageablePageCoverImagesFields as ICoverImages } from '../../generated/graphql';

import { getNodesFromConnection } from '@graphql/connections/getNodesFromConnection';

export const getCoverImage = (coverImages: ICoverImages | undefined): string => {
  const nodes = getNodesFromConnection(coverImages);
  return nodes[0]?.url ?? '';
};
